/**
 * @generated SignedSource<<684d6fc6fc22053e8c6ce2b35424ac44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopyToModalBlock$data = ReadonlyArray<{
  readonly descendants: ReadonlyArray<{
    readonly type: string;
  }>;
  readonly id: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"QuotedItemBlock">;
  readonly " $fragmentType": "CopyToModalBlock";
}>;
export type CopyToModalBlock$key = ReadonlyArray<{
  readonly " $data"?: CopyToModalBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"CopyToModalBlock">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CopyToModalBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuotedItemBlock"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "descendants",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteBlock",
  "abstractKey": null
};
})();

(node as any).hash = "9cb292b984f01c22af2d05dca1f4e1cc";

export default node;
